module.exports = __webpack_public_path__ + "img/9788982730009.c3be0868.jpg";